var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner_box"},[_c('img',{staticClass:"banner_img",attrs:{"src":_vm.bannerImgUrl,"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }